/**
 * Números de telefone permitidos do órgão
 * Apenas registros com destino correspondente a estes números serão exibidos
 */
export const ALLOWED_PHONE_NUMBERS = [
  '+557931421631',
  '+557931421632',
  '8888',
];

/**
 * Normaliza um número de telefone removendo caracteres especiais
 * @param {string} phoneNumber - Número de telefone a ser normalizado
 * @returns {string} - Número normalizado (apenas dígitos)
 */
export const normalizePhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return '';
  // Remove caracteres especiais: +, (, ), -, espaços
  return String(phoneNumber).replace(/[\s\+\-\(\)]/g, '');
};

/**
 * Verifica se um número de telefone corresponde a um dos números permitidos
 * @param {string} phoneNumber - Número de telefone a ser verificado
 * @returns {boolean} - True se o número corresponde a um dos permitidos
 */
export const isAllowedPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return false;
  
  const normalized = normalizePhoneNumber(phoneNumber);
  
  // Verifica se o número normalizado corresponde a algum dos números permitidos
  return ALLOWED_PHONE_NUMBERS.some((allowed) => {
    const normalizedAllowed = normalizePhoneNumber(allowed);
    return normalized === normalizedAllowed;
  });
};

